module.exports = __webpack_public_path__ + "static/img/img_logo.123443ef.png";